export default __webpack_public_path__ + "static/media/yellow-shape.9a23cb4c.svg";